import { findCountryWithAgencyConfigForUser } from 'features/auth/helpers';

export const resolveApiKeyForAgency = (agencyId?: number): string | undefined => {
	if (!agencyId) return undefined;
	return findCountryWithAgencyConfigForUser(agencyId)?.apiKey;
};
